import React, { Component } from 'react';
import { getProject } from 'Services/project';
import { injectIntl } from 'react-intl';

import { connect } from 'react-redux';

import { fetchCompetitions } from '../actions';
import filterList from 'Actions/lists';

import { TableList } from '../../../common/components/TableList';
import Row from './Row';
import Breadcrumb from 'FDComponents/Breadcrumb';
import { resetBreadcrumb } from '../../components/Breadcrumb/actions';

import AreaInput from 'FDComponents/areas/Input';

import Layout from 'Components/Layout';
import Paper from '@material-ui/core/Paper';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';

import debounce, { getLinkId } from 'Services/tools';

import queryReducer from 'Services/queriesReducer';
import { parseQuery, stringifyQuery } from 'Services/parseQuery';
import { SearchFilter } from '../../../common/components/SearchFilter';
import { Alert } from "@material-ui/lab";

@injectIntl
@connect((store, props) => ({
  competitions: store.competitions.list,
  fetching: store.competitions.fetching,
  pagination: store.competitions.pagination,
  total: store.competitions.totalItems,
  query: parseQuery(props.location.search),
}))
export default class Competitions extends Component {
  config = {
    filters: [
      {
        type: 'name',
        labelKey: 'filter_name',
      },
      {
        type: 'area',
        input: AreaInput,
        labelKey: 'filter_country',
      },
    ],
    headers: [
      { id: 'translations.name', labelKey: 'field_name' },
      { id: 'area.translations.name', labelKey: 'field_area' },
      { id: 'type', labelKey: 'field_type' },
      { id: 'translations.priority', labelKey: 'field_priority' },
    ],
  };

  componentWillUnmount() {
    debounce(null, null, true);
  }

  componentDidMount() {
    const { dispatch, location } = this.props;
    this.fetchData(location.search);
    dispatch(resetBreadcrumb());
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    const { location: oldLocation } = this.props;
    const { location } = nextProps;

    if (oldLocation.search !== location.search) {
      this.fetchData(location.search);
    }
  }

  fetchData = filter => {
    const { dispatch } = this.props;
    dispatch(fetchCompetitions(filter));
    dispatch(filterList('competitions', filter));
  };

  handleFilters = change => {
    const { name, area } = change;
    const filtersQuery = {
      name,
      area: getLinkId(area),
    };
    this.changeParams({ type: 'SET_FILTER', payload: filtersQuery });
  };
  handlePagination = change => {
    if (change.page) {
      this.changeParams({ type: 'SET_PAGE', payload: change.page });
    } else {
      this.changeParams({ type: 'SET_ITEMS', payload: change.itemsPerPage });
    }
  };
  handleSort = field => {
    this.changeParams({ type: 'SET_SORT', payload: field });
  };

  changeParams = debounce(action => {
    const { history, query, location } = this.props;
    const newParams = queryReducer(query, action);
    const search = stringifyQuery(newParams);
    if (location.search != search) {
      history.push(`${getProject().url}/competitions${search}`);
    }
  }, 500);

  render() {
    const {
      competitions,
      fetching,
      pagination,
      total,
      query,
      intl: { messages: m },
    } = this.props;

    return (
      <Layout
        id="competitions-layout"
        top={<Breadcrumb />}
        main={
          <Paper elevation={2}>
            <Toolbar>
              <Typography variant="h6">{m.app_competitionsList}</Typography>
            </Toolbar>
            <Alert severity="info">
              <a href={`#${getProject().url}/documentation/competitions`} target="_blank">
                {m.read_the_docs}
              </a>
            </Alert>
            <SearchFilter
              form="competitions_filters"
              filters={this.config.filters}
              onChange={this.handleFilters}
              initialValues={query.filters}
            />
            <TableList
              tableData={competitions}
              tableHeaders={this.config.headers}
              query={query}
              onSort={this.handleSort}
              Row={Row}
              loading={fetching}
              pagination={pagination}
              total={total}
              onPaginate={this.handlePagination}
            />
          </Paper>
        }
      />
    );
  }
}
